/**
 * Home Page Client Component — App Router
 *
 * Receives server-fetched data and isMobile as props.
 * isMobile is determined server-side via middleware searchParam rewrite,
 * enabling correct layout from the first paint (no flash).
 */
'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import type {DynamicPageServerSideProps} from '@/_application/core/types';

const HomePageWrapper = dynamic(() =>
    import('@/_application/pages/home/_isr/home-page-wrapper').then(m => m.HomePageWrapper),
);

interface HomePageClientProps {
    variables: DynamicPageServerSideProps['variables'] | null;
    isMobile: boolean;
}

export function HomePageClient({variables, isMobile}: Readonly<HomePageClientProps>) {
    if (!variables) {
        return null;
    }

    return <HomePageWrapper variables={variables} isMobile={isMobile} />;
}
